const sanitizeRouteParam = (value) => {
  if (value == null) {
    return "";
  }

  return String(value).split(/[?&]/, 1)[0].trim();
};

export { sanitizeRouteParam };
